export const createInvoiceDetailState = () => ({
  invoiceData: null,
  paymentMethodOptions: [],
  paymentFormOptions: [],
  serialOptions: [],
  showPayInvoiceModal: false,
  payInvoiceSubmitting: false,
  payInvoiceRow: null,
  showMoreActionsMenu: false,
  showSendEmailModal: false,
  sendEmailModalSubmitting: false,
  invoiceShippingRefreshTick: 0,
});
